// check if SizeGuideDrawer exists before defining it
if (!window.customElements.get('size-guide-drawer')) {
  class SizeGuideDrawer extends Drawer {
    close() {
      this.classList.remove('active');
      removeTrapFocus(this.activeElement);
      if (document.querySelector('shop-the-look-drawer.active')) return;
      document.body.classList.remove('overflow-hidden');
      setTimeout(() => {
        document.body.classList.remove('drawer--isActive');
      }, 300);
    }

    connectedCallback() {
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelector('[id*=-Overlay]').addEventListener('click', this.close.bind(this));
    }
  }

  customElements.define('size-guide-drawer', SizeGuideDrawer);
}
